var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-manager',{attrs:{"canEdit":false,"context":'kiosk-manager',"functionalRoles":_vm.functionalRoles,"toolbarColor":_vm.appColor_GenieLight,"toolbarColorDark":_vm.appColor_Genie}})}
var staticRenderFns = []

export { render, staticRenderFns }